import React from 'react';
import { Card, CardContent, Grid, TextField, CardActions, Button, CardHeader, Typography,
		 List, ListItem, ListItemAvatar, Avatar, ListItemText, ListItemSecondaryAction } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Empty from 'validator/lib/isEmpty';
import { withSnackbar } from 'notistack';
import { MaskDataHora } from '../../../utils/mask';
import moment from 'moment';

//services
import PromocaoAPI from '../../../services/api/Promocao';

import PremioIMG from './empty.png';


class EditarPromocao extends React.Component {
	state = {
		loading:false,

		titulo:'',
		data_inicio: '',
		data_fim: '',
		valor: '',

		logo:'',
		background:'',
		regulamento: '',

		premios: [],

		isTitulo: false,
		isLogo: false,
		isDataInicio: false,
		isDataFim: false,
		isBackground: false,
		isRegulamento: false,
		isValor: false,
		isNome: false,
		isQuantidade: false,

		nome: '',
		quantidade: '',
		foto: '',
		foto_data: '',
	}

	Submit = (event) => {
		const { enqueueSnackbar, history } = this.props;
		const { titulo, data_inicio, data_fim, valor, logo, background, regulamento,
				premios } = this.state;
		const { id } = this.props.match.params;
		event.preventDefault();
		if (Empty(titulo)) {
			this.setState({ isTitulo: true }, () => enqueueSnackbar('Preencha o campo de titulo'));
			return;
		}
		if (valor === '') {
			this.setState({ isValor: true }, () => enqueueSnackbar('Preencha o campo de valor'));
			return;
		}
		if (data_inicio === null) {
			this.setState({ isDataInicio: true }, () => enqueueSnackbar('Preencha o campo de data e hora inicial'));
			return;
		}
		if (data_fim === null) {
			this.setState({ isDataFim: true }, () => enqueueSnackbar('Preencha o campo de data e hora final'));
			return;
		}

		this.setState({ loading:true }, () => enqueueSnackbar("Aguarde efetuando o cadastro.."));
		let forms = {
			titulo: titulo,
			data_inicio: data_inicio,
			data_fim: data_fim,
			valor_cupom: String(valor),
			logo,
			background,
			regulamento,
			premios
		}

		PromocaoAPI.editar(forms,id)
				.then(res => {
					res.json().then(res => {
						if (res.msg) {
							this.setState({ loading: false }, () => enqueueSnackbar(res.msg));
							return;
						}
						this.setState({loading:false});
						enqueueSnackbar('Alteração efetuada com sucesso');
						history.push('/painel/promocoes');
					})
				}).catch(() => this.setState({ loading: false }, () => enqueueSnackbar('Não foi possivel efetuar a alteração, tente novamente mais tarde.')))

		return;
	}

	addPremio = () => {
		const { nome, quantidade, foto, foto_data, premios } = this.state;
		const { enqueueSnackbar } = this.props;
		const premio = {nome, quantidade, foto, foto_data};
		this.setState({ isNome: false, isQuantidade: false })
		if (nome === '') {
			this.setState({ isNome: true }, () => enqueueSnackbar('Preencha o campo de nome'));
			return;
		}
		if (quantidade === '') {
			this.setState({ isQuantidade: true }, () => enqueueSnackbar('Preencha o campo de quantidade'));
			return;
		}
		this.setState({ premios:[...premios, premio], nome: '', quantidade: '', foto: '', foto_data: '' })
	}

	deletePremio = (key) => {
		const { premios } = this.state;
		this.setState({ premios: premios.filter( (p,k) => k !== key ) })
	}

	refreshPremio = () => {
		const { enqueueSnackbar } = this.props;
		const { id } = this.props.match.params;
		PromocaoAPI.get(id).then(res => {
			res.json().then(res => {
				if (res.msg) {
					this.setState({ loading: false }, () => enqueueSnackbar(res.msg));
					return;
				}
				this.setState({
					loading:false,
					titulo: res.titulo,
					data_inicio: moment(res.data_inicio).format('DD/MM/YYYY HH:mm'),
					data_fim: moment(res.data_fim).format('DD/MM/YYYY HH:mm'),
					valor: res.valor_cupom,
					premios: res.premios,
				})
			})
		}).catch(() => this.setState({ loading: false }, () => enqueueSnackbar('Não foi possivel carregar as informações, tente novamente mais tarde.')))
	}

	componentDidMount(){
		this.refreshPremio();
	}

    render() {
		const { titulo, data_inicio, data_fim, nome, quantidade, premios, loading,
				isTitulo, isLogo, isBackground, isRegulamento, isDataInicio, isDataFim,
				valor, isValor, isNome, isQuantidade  } = this.state;
        return (
				<div className="app_control__content_padding" >
					<Grid container spacing={16} >
						<Grid item xs={12} >
							<form onSubmit={this.Submit} >
								<Card elevation={0} >
									<CardHeader title="Editar" />
									<CardContent>
										<Grid container spacing={16} >
											<Grid item xs={6} >
												<TextField
													label="Título"
													value={titulo}
													onChange={e => this.setState({ titulo: e.target.value })}
													margin="normal"
													error={isTitulo}
													variant="outlined"
													fullWidth
												/>
											</Grid>
											<Grid item xs={2} >
												<TextField
														label="Inicio"
														value={data_inicio}
														onChange={e => this.setState({ data_inicio: e.target.value })}
														margin="normal"
														error={isDataInicio}
														variant="outlined"
														InputProps={{
															inputComponent: MaskDataHora,
														}}
														fullWidth
													/>
											</Grid>
											<Grid item xs={2} >
												<TextField
														label="Fim"
														value={data_fim}
														onChange={e => this.setState({ data_fim: e.target.value })}
														margin="normal"
														error={isDataFim}
														variant="outlined"
														InputProps={{
															inputComponent: MaskDataHora,
														}}
														fullWidth
													/>
											</Grid>
											<Grid item xs={2} >
												<TextField
													label="Valor do cupom"
													value={valor}
													onChange={e => this.setState({ valor: e.target.value })}
													margin="normal"
													error={isValor}
													variant="outlined"
													fullWidth
												/>
											</Grid>
											<Grid item xs={4} >
												<TextField
													label="Logo"
													type="file"
													onChange={e => this.setState({ logo: e.target.files[0]})}
													margin="normal"
													variant="outlined"
													fullWidth
													// helperText={`Para seguir o padrão dos icones basta acessar: https://www.flaticon.com`}
													error={isLogo}
													InputLabelProps={{
														shrink:true
													}}
												/>
											</Grid>
											<Grid item xs={4} >
												<TextField
													label="Background"
													type="file"
													onChange={e => this.setState({ background: e.target.files[0]})}
													margin="normal"
													variant="outlined"
													fullWidth
													// helperText={`Para seguir o padrão dos icones basta acessar: https://www.flaticon.com`}
													error={isBackground}
													InputLabelProps={{
														shrink:true
													}}
												/>
											</Grid>
											<Grid item xs={4} >
												<TextField
													label="Regulamento"
													type="file"
													onChange={e => this.setState({ regulamento: e.target.files[0]})}
													margin="normal"
													variant="outlined"
													fullWidth
													// helperText={`Para seguir o padrão dos icones basta acessar: https://www.flaticon.com`}
													error={isRegulamento}
													InputLabelProps={{
														shrink:true
													}}
												/>
											</Grid>
										</Grid>
										<Grid container spacing={16} >
											<Grid item xs={12} md={12} >
												<Typography variant="h5" gutterBottom >Prêmios</Typography>
											</Grid>
											<Grid item xs={12} md={3} >
												<TextField
													label="Nome"
													value={nome}
													onChange={e => this.setState({ nome: e.target.value })}
													margin="normal"
													error={isNome}
													variant="outlined"
													fullWidth
												/>
											</Grid>
											<Grid item xs={12} md={2} >
												<TextField
													label="Quantidade"
													value={quantidade}
													type="number"
													onChange={e => this.setState({ quantidade: e.target.value })}
													margin="normal"
													error={isQuantidade}
													variant="outlined"
													fullWidth
												/>
											</Grid>
											<Grid item xs={3} >
												<Button style={{marginTop:21}} onClick={this.addPremio} size="large" variant="outlined" color="default" >Adicionar</Button>
											</Grid>
											<Grid item xs={12} md={12} >
												{premios.length > 0 && <List style={{ border: '1px dotted #AEAEAE', padding:10 }}  >
													{premios.map((p,k) => <ListItem key={k} >
														<ListItemAvatar>
															<Avatar style={{width:100, height: 100, padding: 10}} >
																<img src={PremioIMG} alt="" width="70%" />
															</Avatar>
														</ListItemAvatar>
														<ListItemText primary={p.nome} secondary={`Quantidade: ${p.quantidade}`} />
														<ListItemSecondaryAction>
															<Button onClick={() => this.deletePremio(k)} variant="outlined" color="default" >
																Remover
															</Button>
														</ListItemSecondaryAction>
													</ListItem>)}
												</List>}
												{!premios.length && <div style={{ padding:50, border: '1px dotted #AEAEAE', textAlign: 'center' }} ><Typography variant="body2" >Nenhum prêmio adicionado.</Typography></div>}
											</Grid>
										</Grid>
									</CardContent>
									<CardActions>
										<Button type="submit" variant="outlined" disabled={loading} color="primary" >Salvar</Button>
										<Button variant="outlined" color="inherit" component={Link} to="../promocoes" >Cancelar</Button>
									</CardActions>
								</Card>
							</form>
						</Grid>
					</Grid>
				</div>
        );
    }
}

export default withSnackbar(EditarPromocao);



// WEBPACK FOOTER //
// ./src/painel/pages/promocoes/editar.js